const React = require('react');

const ListingPlaceholder = () =>
  <div className="product-row-card product-row-card--placeholder">
    <div className="product-row-card__image"></div>
    <div className="product-row-card__title"></div>
    <div className="product-row-card__location"></div>
    <div className="product-row-card__actions">
      <a className="product-row-card__placeholder-button">&nbsp;</a>
      <a className="product-row-card__placeholder-button">&nbsp;</a>
      <a className="product-row-card__placeholder-button">&nbsp;</a>
    </div>
  </div>;

module.exports = ListingPlaceholder;



// WEBPACK FOOTER //
// ./javascripts/components/comparison_shopping_page/listing_placeholder.jsx